module.exports = __webpack_public_path__ + "static/media/logo.aedbf7f6.svg";